import TurnInfo from "../types/TurnInfo";

export function getTurnAtIndex(index: number, turns: TurnInfo[]) {
    return turns.sort((a, b) => a.id - b.id).reverse().at(index)
}

export function getLastTurnsFromOtherPlayers(turns: TurnInfo[]): TurnInfo[] {
    return turns.slice(1, 2)
}